module.exports = require('./helpers/bundle-url').getBundleURL('iwMWQ') + "logo-dark.eefe0b7f.svg";